import React, { ReactNode } from "react"
import { AppHeader } from "./AppHeader"
import { AppFooter } from "./AppFooter"


type AppLayoutProps = {
    children: ReactNode
}

export const AppLayout = ({ children } : AppLayoutProps) => {
    return (
        <>
        <AppHeader/>
        { children }
        <AppFooter/>
        </>
    )
}